"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYCVerification = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var sampleAppController_1 = require("../../facetec/src/sampleAppController");
var get_firebase_user_profile_1 = require("../api/calls/user/get_firebase_user_profile");
var Config_1 = require("../Config");
var verification_copy_1 = require("../constants/verification_copy");
var user_profile_1 = require("../features/slices/user-profile");
var user_state_1 = require("../utils/user-state");
var KYCVerification = function (_a) {
    var onKYCComplete = _a.onKYCComplete, onError = _a.onError, _b = _a.isManualNavigation, isManualNavigation = _b === void 0 ? false : _b;
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.auth; });
    var firebaseProfile = (0, react_redux_1.useSelector)(function (state) {
        return state.userProfile.profile;
    });
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, react_1.useState)(true), isCheckingStatus = _d[0], setIsCheckingStatus = _d[1];
    var _e = (0, react_1.useState)("Pending"), kycStatus = _e[0], setKycStatus = _e[1];
    var profileRefreshRequestedRef = (0, react_1.useRef)(false);
    var facetecCompleteHandlerRef = (0, react_1.useRef)();
    // Check if user already has KYC completed
    (0, react_1.useEffect)(function () {
        // Listen for FaceTec completion events dispatched from PhotoIDMatchProcessor
        var handler = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsLoading(false); // stop button spinner
                        setKycStatus("In Progress"); // trigger a profile refresh pass
                        profileRefreshRequestedRef.current = false;
                        if (!(user === null || user === void 0 ? void 0 : user.firebase_user_id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, get_firebase_user_profile_1.get_firebase_user_profile)(user.firebase_user_id)];
                    case 1:
                        res = _b.sent();
                        if (res.success && ((_a = res.content) === null || _a === void 0 ? void 0 : _a.sanitized)) {
                            dispatch((0, user_profile_1.setFirebaseUserProfile)(res.content.sanitized));
                        }
                        else if (!res.success) {
                            dispatch((0, user_profile_1.setUserProfileError)(res.message));
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        facetecCompleteHandlerRef.current = handler;
        window.addEventListener("facetec-idscan-complete", handler);
        return function () {
            if (facetecCompleteHandlerRef.current) {
                window.removeEventListener("facetec-idscan-complete", facetecCompleteHandlerRef.current);
            }
        };
    }, [dispatch, user === null || user === void 0 ? void 0 : user.firebase_user_id]);
    (0, react_1.useEffect)(function () {
        var checkKYCStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // If user is not authenticated yet, stop spinner and wait
                        if (!(user === null || user === void 0 ? void 0 : user.user_id)) {
                            setIsCheckingStatus(false);
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 6]);
                        setIsCheckingStatus(true);
                        // Check if user has FaceTec enrolled (required for KYC)
                        if (!(user === null || user === void 0 ? void 0 : user.facetecDBRef)) {
                            console.warn("❌ No facetecDBRef found for user");
                            setKycStatus(verification_copy_1.FACIAL_RECOGNITION_REQUIRED);
                            onError("Please complete Facial Recognition enrolment before proceeding with KYC verification.");
                            setIsCheckingStatus(false);
                            return [2 /*return*/];
                        }
                        if (!(kycStatus === "In Progress" &&
                            (user === null || user === void 0 ? void 0 : user.firebase_user_id) &&
                            !profileRefreshRequestedRef.current)) return [3 /*break*/, 3];
                        profileRefreshRequestedRef.current = true;
                        return [4 /*yield*/, (0, get_firebase_user_profile_1.get_firebase_user_profile)(user.firebase_user_id)];
                    case 2:
                        res = _b.sent();
                        if (res.success && ((_a = res.content) === null || _a === void 0 ? void 0 : _a.sanitized)) {
                            dispatch((0, user_profile_1.setFirebaseUserProfile)(res.content.sanitized));
                        }
                        else if (!res.success) {
                            dispatch((0, user_profile_1.setUserProfileError)(res.message));
                        }
                        _b.label = 3;
                    case 3:
                        // PRIORITY 2: Check if user is already verified via any of the
                        // ecosystem's sumsub field variants — Lewfin's SumSubApproved
                        // (Redux or Firestore user doc) OR Sky Lifestyle's sumsub_complete
                        // on the shared Firestore user doc (see isKycVerified in
                        // app/utils/user-state.ts).
                        if ((0, user_state_1.isKycVerified)(user, firebaseProfile)) {
                            setKycStatus("Completed");
                            setIsCheckingStatus(false);
                            // Only auto-complete if user is NOT manually navigating backwards
                            if (!isManualNavigation) {
                                onKYCComplete();
                            }
                            return [2 /*return*/];
                        }
                        // Not approved yet - allow user to proceed with verification UI
                        setKycStatus("Pending");
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _b.sent();
                        console.error("KYC status check error:", error_1);
                        return [3 /*break*/, 6];
                    case 5:
                        setIsCheckingStatus(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        checkKYCStatus();
    }, [
        user === null || user === void 0 ? void 0 : user.user_id,
        user === null || user === void 0 ? void 0 : user.SumSubApproved,
        firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.SumSubApproved,
        firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.sumsub_complete,
        kycStatus,
        dispatch,
        onError,
        onKYCComplete,
    ]);
    var handleVerifyIdentity = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                setIsLoading(true);
                setKycStatus("In Progress");
                profileRefreshRequestedRef.current = false; // allow a fresh profile fetch after verification starts
                // Check if FaceTec SDK is initialized
                if (!Config_1.Config.didSucceed) {
                    throw new Error("Facial Recognition is not ready. Please try again in a moment.");
                }
                // Check if user has FaceTec enrollment
                if (!(user === null || user === void 0 ? void 0 : user.facetecDBRef)) {
                    throw new Error("Facial Recognition enrolment required before KYC verification.");
                }
                // Start FaceTec PhotoID Match process (KYC verification)
                sampleAppController_1.SampleApp.onPhotoIDMatchPressed();
                // The monitoring useEffect will handle completion detection
                // No need for manual completion here - FaceTec updates user state
            }
            catch (error) {
                console.error("KYC verification error:", error);
                setIsLoading(false);
                setKycStatus("Failed");
                onError(error instanceof Error ? error.message : "KYC verification failed");
            }
            return [2 /*return*/];
        });
    }); };
    if (isCheckingStatus) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center py-12", children: [(0, jsx_runtime_1.jsx)("div", { className: "animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" }), (0, jsx_runtime_1.jsx)("p", { className: "mt-4 text-gray-600", children: "Checking verification status..." })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center py-12 space-y-8", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-32 h-32 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center", children: (0, jsx_runtime_1.jsx)("svg", { className: "w-16 h-16 text-blue-600", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "max-w-md text-center space-y-4", children: [(0, jsx_runtime_1.jsx)("h3", { className: "text-xl font-semibold text-gray-900", children: (0, user_state_1.isKycVerified)(user, firebaseProfile)
                            ? "Identity Verified"
                            : "Identity Verification Required" }), (0, user_state_1.isKycVerified)(user, firebaseProfile) ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "text-gray-600", children: "Your identity has been successfully verified. You can proceed with your loan application." }), (0, jsx_runtime_1.jsxs)("p", { className: "text-sm font-medium text-gray-700", children: ["Verification Status:", " ", (0, jsx_runtime_1.jsx)("span", { className: "text-green-600", children: kycStatus })] })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "text-gray-600", children: "We need to verify your identity to comply with financial regulations. Please proceed by clicking the \"Verify Identity\" button below." }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-500", children: "You will need your government issued ID document to complete this process." }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-500", children: "The verification process takes approximately 2 minutes." }), (0, jsx_runtime_1.jsxs)("p", { className: "text-sm font-medium text-gray-700", children: ["Verification Status:", " ", (0, jsx_runtime_1.jsx)("span", { className: "text-blue-600", children: kycStatus })] })] }))] }), (0, jsx_runtime_1.jsx)("div", { className: "w-64", children: (function () {
                    var isAlreadyVerified = (0, user_state_1.isKycVerified)(user, firebaseProfile);
                    return ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: isAlreadyVerified
                            ? "Already Verified"
                            : isLoading
                                ? "Verifying..."
                                : "Verify Identity", onClick: isAlreadyVerified || isLoading ? function () { } : handleVerifyIdentity, backgroundColor: isAlreadyVerified || isLoading ? "bg-gray-400" : "bg-red-600", textColor: "text-white", loading: isLoading }));
                })() }), (0, jsx_runtime_1.jsx)("div", { id: "kyc-status", className: "hidden" }), (0, jsx_runtime_1.jsx)("div", { className: "max-w-md text-center", children: (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-gray-400", children: "Your personal information is protected and secure. We use industry-standard encryption and comply with all relevant data protection regulations." }) })] }));
};
exports.KYCVerification = KYCVerification;
exports.default = exports.KYCVerification;
